















































import { Component, Prop, Vue } from "vue-property-decorator"
import CapPrintVue from "./CapPrint.vue"
import ReportMarginVue from "./ReportMargin.vue"

@Component({
    components: {
        "cap": CapPrintVue,
        "report-margin": ReportMarginVue
    }
})
export default class IntangPrint extends Vue {
    @Prop({ type: Array })
    dataList!: FixedAsset.FiexdFad[];

    @Prop({ type: String })
    period!: string;

    @Prop({ type: String })
	fontSize!: string;
}
